import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {};

export const CcustoValorContext = createContext();

export const CcustoValorProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [ccustoValor, setCcustoValor] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getCcustoValor = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: ccustoValor?.filter,
        page: ccustoValor?.page,
        size: ccustoValor?.size,
        order: ccustoValor?.order,
        ...payload,
      });
      setCcustoValor((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <CcustoValorContext.Provider
      value={{
        getLoading,
        ccustoValor,
        getCcustoValor,
      }}
    >
      {children}
    </CcustoValorContext.Provider>
  );
};
